export const nicheCategories = [
    {
        "category": "FOOD",
        "subcategories": ["Food", "F&B", "Restaurant", "beverage", "event", "cafe"]
    },
    {
        "category": "FASHION RELATED", 
        "subcategories": ["luxury", "fashion", "clothing", "jewel", "clothes"]
    },
    {
        "category": "FINANCE",
        "subcategories": ["finance", "invest"]
    },
    {
        "category": "LIFESTYLE & TRAVEL",
        "subcategories": ["lifestyle", "travel"]
    },
    {
        "category": "FAMILY",
        "subcategories": ["parenting", "family", "kids", "children"]
    },
    {
        "category": "HOME",
        "subcategories": ["home", "living", "household"]
    },
    {
        "category": "BEAUTY",
        "subcategories": ["beauty", "skincare", "makeup"]
    },
    {
        "category": "HEALTH",
        "subcategories": ["health", "fitness", "wellness", "gym"]
    },
    {
        "category": "TECH",
        "subcategories": ["tech", "gadget", "electronics", "product"]
    },
    {
        "category": "PETS",
        "subcategories": ["pet", "dog", "cat"]
    }
];
